import styled from 'styled-components';
import { Container as InputContainer } from '../Input/styles';
import ArtplayerComponentBase from 'artplayer-react';
import { lighten, shade } from 'polished';

/********** Header **********/
// Botão de voltar na Header
export const Logo = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 22px;
  height: 100%;
  cursor: pointer;
  padding: 0 15px;
  color: rgba(255, 255, 255, 1);
  transition: all 0.2s ease 0s;
  border-right: 1px solid rgb(0, 0, 0);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
  text-decoration: none;

  &:hover {
    background-color: #2196f3;
  }
`;

// Cada botão da Header (Carregar/Importar/Exportar/Undo/Apagar)
export const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  height: 100%;
  cursor: pointer;
  padding: 0 25px;
  color: rgba(255, 255, 255, 1);

  transition: all 0.2s ease 0s;
  border-right: 1px solid rgb(0, 0, 0);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);

  background-color: ${props =>
    props.reverse ? props.theme.button[props.color || 'primary'].in : null};
  &:hover {
    background-color: ${props =>
      props.reverse
        ? props.theme.button[props.color || 'primary'].out
        : props.theme.button[props.color || 'primary'].out};
  }

  &:disabled {
    opacity: 0.6;
  }

  svg {
    margin-right: 5px;
  }
`;

// Botões de Salvar e Finalizar Legenda
export const RightHeader = styled.div`
  display: flex;
  height: 100%;
`;

// Toda a header exceto os botões de Salvar e Finalizar
export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  flex: 1;
`;

// Toda a Header
export const Header = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  background-color: #1f2133;
  border-bottom: 1px solid rgb(0, 0, 0);
  p {
    color: ${props => props.theme.lightFontColor};
  }
`;

/********** Player **********/
// Player com a borda
export const Player = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70%;
  width: 100%;
  padding: 20px;
`;

// Player apenas borda inferior
export const ArtplayerComponent = styled(ArtplayerComponentBase)`
  .art-subtitle {
    p {
      color: #fff;
      font-size: 1.2em !important;
    }
  }
`;

// Área dos botões de offset
export const Tool = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  align-items: center;
  .item {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);

    .value {
      display: flex;
      align-items: center;
      select {
        outline: none;
        margin-left: 15px;
      }
    }
  }
`;

// Área do player e botões de offset
export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  border-right: 1px solid #000;
`;

/********** Edição **********/
// Área de edição de legendas
export const Subtitle = styled.div`
  .ReactVirtualized__Table {
    font-size: 12px;
    .ReactVirtualized__Table__Grid {
      outline: none;
    }
    .ReactVirtualized__Table__row {
      transition: all 0.2s ease;
      width: 100% !important;
      &.odd {
        background-color: #22273f;
      }
      &.highlight {
        background-color: #2196f3;
      }
      &.illegal {
        background-color: #c75123;
      }
      .row {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #fff;
        height: 100%;
        padding: 10px 5px;
        border-bottom: 1px solid #000;
        button {
          // Para deixar o hover dos botões redondos
          min-width: 0;
        }
      }
    }
    .input,
    .textarea {
      border: none;
      width: 100%;
      color: #fff;
      overflow: hidden; //para não criar scroll na TextArea
      font-size: 16px; //Alterado fonte das caixas de texto a direita
      text-align: center;
      background-color: rgba(0, 0, 0, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.1);
      resize: none;
      outline: none;
    }
    .input {
      height: 25px;
      line-height: 25px;
      cursor: col-resize;
      user-select: none;
    }
    .textarea {
      padding: 5px;
      /* padding: 5px 127px 5px; */
      height: 100%;
      line-height: 1.5;
    }
    .operation {
      i {
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
`;

// Div pai da área de edição de legendas
export const Right = styled.div`
  display: flex;
  height: calc(100vh - 260px);
  flex: 1;
`;

/********** Main **********/
// Player + Botões Offset + Edição de legendas
export const Main = styled.div`
  background-color: #1e1e24;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex: 1;
  border-bottom: 1px solid #000;
  p,
  svg {
    color: ${props => props.theme.lightFontColor};
  }
`;

/********** Footer **********/
// Timeline
export const Block = styled.div`
  position: absolute;
  z-index: 6;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  .contextmenu {
    position: absolute;
    z-index: 4;
    left: 0;
    top: 0;
    pointer-events: all;
    .contextmenu-item {
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      cursor: pointer;
      font-size: 12px;
      color: #ccc;
      user-select: none;
      background-color: rgba(0, 0, 0, 0.75);
      transition: all 0.2s ease;
      &:hover {
        color: #fff;
        background-color: #2196f3;
      }
    }
  }
  .sub-item {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    font-size: 13px;
    cursor: move;
    user-select: none;
    pointer-events: all;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
    background-color: rgba(255, 255, 255, 0.2);
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
    }
    &.sub-highlight {
      background-color: rgba(33, 150, 243, 0.5);
      border-left: 1px solid rgba(33, 150, 243, 0.5);
      border-right: 1px solid rgba(33, 150, 243, 0.5);
    }
    &.sub-illegal {
      background-color: rgba(199, 81, 35, 0.5);
    }
    .sub-handle {
      position: absolute;
      top: 0;
      bottom: 0;
      height: 100%;
      cursor: col-resize;
      user-select: none;
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
    .sub-text {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      word-break: break-all;
      width: 100%;
      height: 100%;
      padding: 0 20px;
      p {
        /* font-size: 16px; */ //Descomente Para alterar o tamanho da fonte do footer
        margin: 5px 0;
        line-height: 1;
      }
    }
  }
`;

// Waveform
export const Metronome = styled.div`
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  user-select: none;
  .templet {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    background-color: rgba(76, 175, 80, 0.5);
    border-left: 1px solid rgba(76, 175, 80, 0.8);
    border-right: 1px solid rgba(76, 175, 80, 0.8);
    user-select: none;
    pointer-events: none;
  }
`;

// Timeline + botões de controle da timeline
export const Footer = styled.div`
  background-color: #1e1e24;
  display: flex;
  flex-direction: column;
  height: 200px;
  .timeline-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    font-size: 12px;
    border-bottom: 1px solid #000;
    color: rgba(255, 255, 255, 0.5);
    background-color: rgba(0, 0, 0, 0.3);
    .timeline-header-left {
      display: flex;
      align-items: center;
      height: 100%;
      .item {
        display: flex;
        padding: 0 10px;
        height: 100%;
        border-right: 1px solid #000;
        .name {
          display: flex;
          align-items: center;
          margin-right: 10px;
        }
        .value {
          display: flex;
          align-items: center;
          input[type='checkbox'] {
            outline: none;
          }
          input[type='range'] {
            height: 3px;
            width: 100px;
            outline: none;
            appearance: none;
            background-color: rgba(255, 255, 255, 0.2);
          }
          select {
            outline: none;
          }
        }
      }
    }
    .timeline-header-right {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 15px;
      border-left: 1px solid #000;
    }
  }
  .timeline-body {
    position: relative;
    flex: 1;
    .waveform {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      user-select: none;
      pointer-events: none;
    }
  }
  p {
    color: ${props => props.theme.lightFontColor};
  }
`;

/********** Importar Legenda **********/
// Container de busca de retrancas em Importar Legenda
export const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 15px;
  min-height: 400px;

  form {
    display: flex;
    align-items: center;
    width: 100%;
    input {
      background-color: #31334d;
      color: hsla(0, 0%, 100%, 0.8);
      flex: 1;
      min-height: 40px;
      border-radius: 0.2857rem 0 0 0.2857rem;
      border: 1px solid hsla(0, 0%, 100%, 0.15);
    }
    ${InputContainer} {
      flex: 1;
      height: 38px !important;
    }
    button {
      width: 50px;
      border-radius: 0 0.2857rem 0.2857rem 0;
    }
  }
  svg {
    margin: 0;
  }
`;

// Retrancas na busca por Importar Legenda
export const Item = styled.a`
  display: flex;
  height: 48px;
  margin-top: 0px;
  width: 100%;
  cursor: pointer;

  & + a {
    margin-top: 5px;
  }

  span {
    width: 5px;
    height: 48px;
    background-color: ${props =>
      props.theme.flag[props.status || 'indisponivel']};
  }

  div {
    margin-left: 5px;
    padding: 5px 5px 0;
    p {
      font-weight: 600;
    }
    strong {
      font-weight: normal;
      font-size: 12px;
      opacity: 0.8;
      font-style: italic;
      color: ${props => props.theme.lightFontColor};
    }
  }

  svg {
    position: absolute;
    left: auto;
    right: 13px;
    margin-top: 17px;
    color: ${props => props.theme.lightFontColor};
  }

  transition: background-color 0.2s;

  &:hover {
    background-color: ${props =>
      props.theme.name === 'dark'
        ? lighten(0.1, props.theme.background)
        : shade(0.2, props.theme.background)};
  }
`;

/********** Carregar **********/

// Modal para carregar arquivo (video/legenda)
export const Dialog = styled.div`
  position: fixed;
  //z-index:21 porque o player do CC tem z-index:20
  z-index: 21;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);

  .dialog-content {
    min-height: 400px;
  }

  .dialog-inner {
    min-height: 200px;
    background-color: #1f2133;
    border-radius: 3px;
    overflow: hidden;
    opacity: 0;
    margin-top: -10px;
    transition: all 0.2s ease 0s;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);

    .dialog-title {
      position: relative;
      border-bottom: 1px solid #000;
      background-color: #2a2c3c;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
      margin-bottom: 10px;
      font-size: 16px;
    }

    .dialog-cancel {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      opacity: 0.5;
      transition: all 0.2s ease 0s;

      &:hover {
        opacity: 1;
      }
    }

    &.dialog-active {
      opacity: 1;
      margin-top: 0;
    }
  }
`;

// Dentro do Modal de carregar arquivo
export const Upload = styled.div`
  .item {
    margin-bottom: 20px;
    .title {
      color: #fff;
      font-size: 14px;
      padding: 5px 10px;
      margin-bottom: 10px;
      border-left: 2px solid #03a9f4;
    }
    .centent {
      padding: 0 10px;
      .upload {
        position: relative;
        margin-bottom: 10px;
        .input {
          width: 100%;
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          outline: none;
          border: none;
          color: #fff;
          background-color: #363952;
        }
        .file {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          line-height: 1;
          height: 100%;
          width: 100px;
          color: #fff;
          background-color: #2196f3;

          input {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }
      .info {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 10px;
      }
      .warning {
        font-size: 12px;
        padding: 5px;
        color: #fff;
        background-color: rgba(199, 81, 35, 0.5);
        border: 1px solid rgba(199, 81, 35, 1);
      }
    }
  }
`;
